import axios from 'axios';
import config from './config';
import { util, lg } from 'utils';

let base = util.getDomain();

/*发货*/

export const GetERP_SendGoodsByPage = params => { return axios.get(`${base}/api/SendGoods/GetERP_SendGoodsByPage`, { params: params }); };
export const GetSendGoodsForBus = params => { return axios.get(`${base}/api/SendGoods/GetSendGoodsForBus`, { params: params }); };
export const GetSendGoodsForStock = params => { return axios.get(`${base}/api/SendGoods/GetSendGoodsForStock`, { params: params }); };
export const ERP_AuditSendGoods = params => { return axios.get(`${base}/api/SendGoods/ERP_AuditSendGoods`, { params: params }); };
export const GetERP_SendGoodsById = params => { return axios.get(`${base}/api/SendGoods/GetERP_SendGoodsById`, { params: params }); };
export const ERP_SendGoodsDel = params => { return axios.post(`${base}/api/SendGoods/ERP_SendGoodsDel`, params, config); };//删除
export const ERP_InvalidSendGoods = params => { return axios.get(`${base}/api/SendGoods/ERP_InvalidSendGoods`, { params: params }); };//作废
export const ViewSendGoodsForBus = params => { return axios.get(`${base}/api/SendGoods/ViewSendGoodsForBus`, { params: params }); };//发货通知(商务)——查看
export const ViewSendGoodsForStock = params => { return axios.get(`${base}/api/SendGoods/ViewSendGoodsForStock`, { params: params }); };//发货通知(仓库)——查看
export const GetStockOutBySendId = params => { return axios.get(`${base}/api/SendGoods/GetStockOutBySendId`, { params: params }); };//生成出库单 加载数据
export const GetSendGoodsAuditStatistics = params => { return axios.get(`${base}/api/SendGoods/GetSendGoodsAuditStatistics`, { params: params }); };//生成出库单 加载数据
export const LoadDataForSendPrint = params => { return axios.get(`${base}/api/SendGoods/LoadDataForSendPrint`, { params: params }); };//打印发货单
export const LoadThirdDataForSendPrint = params => { return axios.get(`${base}/api/SendGoods/LoadThirdDataForSendPrint`, { params: params }); };//打印发货单



export const GetSendGoodsStockList = params => { return axios.get(`${base}/api/SendGoods/GetSendGoodsStockList`, { params: params }); };//打印发货单tongzhi
export const SendGoodsPrint = params => { return axios.get(`${base}/api/SendGoods/SendGoodsPrint`, { params: params }); };//打印发货单tongzhi
export const GetOtherSendGoodsByPage = params => { return axios.get(`${base}/api/SendGoods/GetOtherSendGoodsByPage`, { params: params }); };//第三方发货通知单列表
export const ViewSendGoodsForThird = params => { return axios.get(`${base}/api/SendGoods/ViewSendGoodsForThird`, { params: params }); };//第三方发货通知单-查看
export const GetThirdStockOutBySendId = params => { return axios.get(`${base}/api/SendGoods/GetThirdStockOutBySendId`, { params: params }); };//第三方发货通知单--生成出库单初始化数据




// WEBPACK FOOTER //
// ./src/api/sendGoodsApi.js